import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { useRecoilQuery } from '../../../../../../../../hooks/useRecoilQuery';
import { fixedFeeTermDetailsQuery } from '../../../../../../../../store/fixedFee/selector';
import { FixedFeeTerm, FixedFeeTermDetailed } from '../../../../../../../../store/fixedFee/types';
import { FixedFeeTermDetailsLoading } from '../FixedFeeTermDetailsLoading';

import { FixedFeeTermDetailsDesktop } from './desktop';
import { FixedFeeTermDetailsMobile } from './mobile';

export interface FixedFeeTermDetailsReceivedProps {
  fixedFeeTerm: FixedFeeTerm;
}

export interface FixedFeeTermDetailsProps extends FixedFeeTermDetailsReceivedProps {
  fixedFeeTermDetailed: FixedFeeTermDetailed;
}

export const FixedFeeTermDetails: React.FC<FixedFeeTermDetailsReceivedProps> = ({
  fixedFeeTerm,
}) => {
  const { data, loading } = useRecoilQuery(
    fixedFeeTermDetailsQuery({ feeBasedContractId: fixedFeeTerm.feeBasedContractId }),
    { cachePolicy: 'no-cache' }
  );

  const elementToRender = useBreakpointValue({
    base: 'mobile',
    sm: 'mobile',
    lg: 'desktop',
  } as unknown as 'mobile' | 'desktop');

  if (loading || !data?.data) {
    return <FixedFeeTermDetailsLoading />;
  }

  if (elementToRender === 'mobile') {
    return (
      <FixedFeeTermDetailsMobile fixedFeeTermDetailed={data?.data} fixedFeeTerm={fixedFeeTerm} />
    );
  }

  if (elementToRender === 'desktop') {
    return (
      <FixedFeeTermDetailsDesktop fixedFeeTermDetailed={data?.data} fixedFeeTerm={fixedFeeTerm} />
    );
  }

  return null;
};
